import Fleets from './fleets';
import FleetManage from './fleet_manage';
import CommissionedDeviceView from './commissioned_device_view';

export {
  Fleets,
  FleetManage, 
  CommissionedDeviceView 
};
